<template>
  <section v-if="history" @mouseleave="closeModal" class="history-container">

    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
            v-for="tab in tabs"
            :key="tab.id"
            class="router-link"
            @click="updateTab(tab)"
            :class="{ active: selectedTab.name === tab.name }"
        >{{tab.name}}
        </li>
      </ul>
    </div>
    <div v-if="selectedTab.name==='Logs'" class="history-table-container">
      <table  class="logs-container">
        <thead>
        <tr>
          <th>ID</th>
          <th>CLIENT ID</th>
          <th>ASSET</th>
          <th >OPERATION</th>
          <th >SECTION</th>
          <th>FROM</th>
          <th>TO</th>
          <th>CREATED AT</th>
        </tr>
        </thead>
        <tr v-for="actLog in history" :key="actLog.id">
          <td>{{actLog.id}}</td>
          <td>{{actLog.client_id?actLog.client_id:"--"}}</td>
          <td>{{actLog.asset?actLog.asset:"--"}}</td>
          <td>{{getParsedOperation(actLog)}}</td>
          <td>{{actLog.entity_name?actLog.entity_name:"--"}}</td>
          <td>{{actLog.from?actLog.from:"--"}}</td>
          <td>{{actLog.to?actLog.to:"--"}}</td>
          <td>{{formatDate(actLog.created_at)}}</td>
        </tr>
      </table>
    </div>
    <div v-if="selectedTab.name==='Messages'" class="viki-messages-container">
      <div class="messages-container" v-if="userMessages.length">
        <table class="messages-container">
          <thead>
          <th>IDX</th>
          <th>TYPE</th>
          <th>MESSAGE</th>
          <th>CREATED AT</th>
          </thead>
          <tr v-for="(message,idx) in userMessages" :key="idx">
            <td>{{idx}}</td>
            <td>{{message.type}}</td>
            <td>{{message.message}}</td>
            <td>{{formatDate(message.created_at)}}</td>

          </tr>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import SocketEndpoints from "../../../mixins/system/SocketEndpoints";

import apiClientCreator from "../../../helpers/api/request";
import moment from 'moment';
export default {
  name: "HistoryPopup",
  mixins:[SocketEndpoints],
  data() {
    return {
      history: null,
      tabs:[
          {id:1,name:'Logs'}
          ,{id:2,name:'Messages'}],
      selectedTab:{id:1,name:'Logs'},
      userMessages:null
    };
  },
  methods: {
    closeModal() {
      this.$emit("onCloseModal");
    },
    async fetchHistory() {
      try {
        const apiClient = apiClientCreator("users/activity_logs");
        const { data } = await apiClient.get();
        this.history = data;
      } catch (err) {

      }
    },
    formatDate(date){
      // return new Date(date).toLocaleDateString()
      if(!date) return "--"
      return moment(date).format("DD/MM, HH:mm")
    },
    getParsedOperation(actLog){
      let {operation}=actLog;
      // if(actLog.entity_name==="VIKI_MSG"){
      //   return JSON.parse(operation).msg;
      // }
      if(!operation) return "--"
      operation=JSON.parse(operation)
      let keys = Object.keys(operation);
      let strToReturn =''
      keys.forEach(key=>strToReturn+=key+', ')
      return strToReturn;
    },
    updateTab(tab){
      this.selectedTab=  tab ;
    },
  },

  mounted() {
    this.fetchHistory();
    this.msgSocket.on("receiveAllMessages",data=>{
      this.userMessages = data
    })
  },
  computed:{

  },
  watch:{
    selectedTab:function(){
      if(this.selectedTab.name==="Messages"){
        this.msgSocket.emit("all_messages",this.auth.user.id);
      }
    }

  }
};
</script>

<style scoped>
.history-container {
  font-family: Montserrat, serif;
  direction: rtl;
  position: fixed;
  bottom: 53vh;
  left: 27vw;
  width: 45vw;
  height: 26vh;
  overflow-y: scroll;
  z-index: 1000;
  background-color: #ffffff;
  font-weight: normal;
  font-size: 12px;
  -webkit-box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
  text-align: center;
  border-radius: 8px;
}
.history-table-container{
  direction: ltr;
}

.viki-messages-container{
  direction: ltr;
}


table{
  width: 95%;
  margin: 10px auto;
  border-radius: 15px;

}
.history-container::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.history-container::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.history-container::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 3px;
}

th{
  text-align: center;
  border-bottom: 1px solid lightgrey;
  padding-right: 4px;

}
td{
  padding: 4px;
  border-bottom: 1px solid lightgrey;
  max-width: 40ch;
}
tr:nth-child(odd) {
  background-color: #7a7a7a0d;
}
thead{
  background: lightgrey;
}
.style-nav .router-link {
  max-width: 150px;
  min-width: 72px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 11px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.3s ease, color 0.3s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}
.style-nav.style1{
  direction: ltr;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
}
.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
</style>